import { format, parseISO } from "date-fns"
import { FormComponentType } from "@components/FormBuilder/types"
import { GenericForm } from "@custom-types/form"

export const MAX_LENGTH_MULTILINE_INPUT = 500
export const MAX_LENGTH_INPUT = 500

export const BASEGRAPH_FORM_FIELDS: GenericForm = {
  key: {
    title: "Name",
    editable: false,
    type: FormComponentType.NameInput,
  },
  description: {
    title: "Description",
    editable: true,
    type: FormComponentType.Textarea,
  },
  product_key: {
    title: "Product Key",
    editable: false,
    type: FormComponentType.Input,
  },
  creator_email: {
    title: "Creator Email",
    editable: false,
    type: FormComponentType.Input,
  },
  s3_location: {
    title: "S3 Location",
    editable: false,
    type: FormComponentType.Input,
  },
  version: {
    title: "Version",
    editable: false,
    type: FormComponentType.Input,
  },
  owner_group_key: {
    title: "Owner Group",
    editable: false,
    type: FormComponentType.Input,
  },
  published: {
    title: "Published",
    editable: false,
    type: FormComponentType.Checkbox,
  },
  creation_date: {
    title: "Creation Date",
    editable: false,
    type: FormComponentType.Date,
    modifier: (value) => format(parseISO(value ? value : new Date().toISOString()), "dd/MM/yyyy"),
  },
  last_updated: {
    title: "Last Updated",
    editable: false,
    type: FormComponentType.Date,
    modifier: (value) => format(parseISO(value ? value : new Date().toISOString()), "dd/MM/yyyy"),
  },
  startDate: {
    title: "Start Date Type",
    editable: true,
    type: FormComponentType.Dropdown,
    options: [
      { id: "fixed", value: "Fixed" },
      { id: "rolling", value: "Rolling" },
    ],
  },
  start_date: {
    title: "Start Date",
    editable: true,
    type: FormComponentType.Date,
    modifier: (value) => format(parseISO(value ? value : new Date().toISOString()), "dd/MM/yyyy"),
  },
  endDate: {
    title: "End Date Type",
    editable: true,
    type: FormComponentType.Dropdown,
    options: [
      { id: "fixed", value: "Fixed" },
      { id: "rolling", value: "Rolling" },
    ],
  },
  end_date: {
    title: "End date",
    editable: true,
    type: FormComponentType.Date,
    modifier: (value) => format(parseISO(value ? value : new Date().toISOString()), "dd/MM/yyyy"),
  },
  rolling_duration: {
    title: "Rolling Duration",
    editable: true,
    type: FormComponentType.Input,
  },
  simulation_frequency: {
    title: "Simulation Frequency",
    editable: true,
    type: FormComponentType.Dropdown,
    options: [
      { id: "yearly", value: "Yearly" },
      { id: "quarterly", value: "Quarterly" },
      { id: "monthly", value: "Monthly" },
    ],
  },
  yearly_rolling_start_month: {
    title: "Yearly Rolling Start Month",
    editable: true,
    type: FormComponentType.Input,
  },
  scenario_source: {
    title: "Scenario Source",
    editable: false,
    type: FormComponentType.Input,
  },
  scenario_version: {
    title: "Scenario Version",
    editable: false,
    type: FormComponentType.Input,
  },
} as const
